import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';

@Component({
    selector: 'xui-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule]
})
export class BannerComponent {
  readonly bgColorClass = input('dark');
  readonly message = input('');
  readonly primaryActionText = input('');
  readonly secondaryActionText = input('');
  readonly useOverlay = input(false);
  readonly primaryAction = output<void>();
  readonly secondaryAction = output<void>();

  onPrimaryAction() {
    this.primaryAction.emit();
  }

  onSecondaryAction() {
    this.secondaryAction.emit();
  }
}
